import { Buffer } from 'buffer';
//Buffer polyfill for use with @aws-crypto/client-browser
// https://stackoverflow.com/questions/68707553/uncaught-referenceerror-buffer-is-not-defined
window.Buffer = Buffer;
